<template>
  <div :class="componentClassName">
    <div class="a-business-hour-input-field__input">
      <a-select-field
        :id="'start_' + id"
        v-model="startTime"
        class="a-business-hour-input-field__start"
        :options="times"
        :show-arrow="false"
        :searchable="true"
        :disabled="disabled"
        :clear-search-on-blur="false"
        :select-field-id="`start-input-${randomID}`"
        :custom-error-message="customErrorMessage"
        @change="handleChange"
      />
    </div>
    <div class="a-business-hour-input-field__separator">-</div>
    <div class="a-business-hour-input-field__input">
      <a-select-field
        :id="'end_' + id"
        v-model="endTime"
        class="a-business-hour-input-field__end"
        :options="times"
        :show-arrow="false"
        :searchable="true"
        :disabled="disabled"
        :clear-search-on-blur="false"
        :select-field-id="`end-input-${randomID}`"
        :custom-error-message="customErrorMessage"
        @change="handleChange"
      />
    </div>
    <div class="a-business-hour-input-field__remove-button">
      <a-button
        :id="'delete_' + id"
        variant="round"
        size="small"
        label="削除"
        color="grey"
        icon="trash"
        :inline="true"
        :disabled="disabled"
        @click="handlePeriodRemoveClick"
      />
    </div>
  </div>
</template>

<script>
import { mapModifiers } from '@/libs/component';
import AButton from '@/components/atoms/button';
import ASelectField from '@/components/atoms/select-field';
import _ from 'lodash';
import { v4 as uuidv4 } from 'uuid';
import { messageContent } from '@/common/messageContent.js';

export default {
  name: 'a-business-hour-input-field',
  components: {
    AButton,
    ASelectField,
  },
  props: {
    class: {
      type: String,
      default: '',
    },
    itemIndex: {
      type: Number,
      default: 0,
    },
    modelValue: {
      type: String,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    id: {
      type: String,
      default: '',
    },
  },
  emits: ['remove', 'change', 'update:modelValue'],
  data() {
    return {
      times: [],
      currentValue: '',
      startTime: '',
      endTime: '',
      randomID: uuidv4(),
      customErrorMessage: messageContent.required15MinutesUnits,
    };
  },
  computed: {
    componentClassName() {
      const baseClassName = mapModifiers('a-business-hour-input-field');
      return `${baseClassName} ${this.class}`.trim();
    },
  },
  watch: {
    modelValue(val, oldValue) {
      this.currentValue = val;
    },
    currentValue(val, oldValue) {
      this.setStartEndValueFromString(val);
    },
  },
  mounted() {
    this.times.splice(0);
    const minutes = ['00', '15', '30', '45'];
    for (let h = 0; h <= 23; h += 1) {
      for (let m = 0; m < minutes.length; m += 1) {
        const time = `${h}:${minutes[m]}`;
        this.times.push({
          value: time,
          label: time,
        });
      }
    }
    // Add 23:59 to pull down list
    this.times.push({
      value: '23:59',
      label: '23:59',
    });
    if (this.modelValue) {
      this.currentValue = this.modelValue;
    }
  },
  methods: {
    handlePeriodRemoveClick(event) {
      this.$emit('remove', this.itemIndex);
    },
    handleChange(data) {
      this.setCurrentValue();
      this.$emit('update:modelValue', this.currentValue);
      this.$emit('change', this.currentValue);
    },
    setStartEndValueFromString(period) {
      const [start, end] = period.split('-');
      this.startTime = start || '';
      this.endTime = end || '';
    },
    setCurrentValue() {
      const start = this.startTime || '';
      const end = this.endTime || '';
      this.currentValue = `${start}-${end}`;
    },
  },
};
</script>
